import React from "react";
import { Link } from "react-router-dom";
import "./CatCard.scss";

const CatCard = ({ card }) => {
  return (
    <Link to={`/gigs?cat=${card?.cat}`}>
      <div className="catCard">
        <img src={card.img} alt="cardImg" />
        <span className="catCard-desc">{card?.desc}</span>
        <span className="catCard-title">{card?.title}</span>
      </div>
    </Link>
  );
};

export default CatCard;
